import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
  id
  fullName
`

export const getRhPeoplesQuery = (brandId, establishmentId) => {
  var debug = `
    query {
      getRhPeoples(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `
  console.log(debug);

  return gql`
    query {
      getRhPeoples(brandId: "${brandId}", establishmentId: "${establishmentId}") {
        ${common}
      }
    }
  `;
}






